var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42 84C65.196 84 84 65.196 84 42C84 18.804 65.196 0 42 0C18.804 0 0 18.804 0 42C0 65.196 18.804 84 42 84Z",
    fill: "#F0EEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8587 29.0628C53.671 24.9801 46.8557 24.9801 42.6671 29.0628C42.4349 29.2892 42.2127 29.5277 42.0003 29.7774C41.7879 29.5269 41.5657 29.2892 41.3327 29.062C37.145 24.9793 30.3296 24.9793 26.1411 29.062C21.9526 33.1447 21.9534 39.7892 26.1411 43.8727L41.4153 58.764C41.5764 58.9211 41.788 59 41.9995 59C42.211 59 42.4226 58.9211 42.5837 58.764L57.8579 43.8727C62.0472 39.79 62.0472 33.1455 57.8587 29.0628Z",
    fill: "#FF3225"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.a627970c9a73002c5e86a32bbb21ce19.svg";
export { ForwardRef as ReactComponent };